import { useAccount } from 'wagmi'
import styled from "styled-components";



export default function TotalDebt( { handleClose, balanceObj }) {
  const { address, connector, isConnected } = useAccount()
  
  return (
    <Modal>
      <div className='content'>
        <div className='top'>
          <div className='title'>Total Debt: ${balanceObj}</div>
          <div className='sub-title'>Your total debt is divided into 'Solid debt' and 'Liquid debt'. The solid debt is fixed in value, while the liquid debt fluctuates independent of their original staked value. It is the network's exchange rates and the composition of the debt pool that they are based on.</div>
          <div className='border-1'></div>
          <div className='debt-info'>
            <div className='info-item'>
              <span>Solid Debt:</span>
              <span>${balanceObj}</span>
            </div>
            <div className='info-item book-item'>
              <span>Liquid Debt:</span>
              <span>$0.20</span>
            </div>
          </div>
        </div>        
        <div className='border-2'></div>
        <div className='btns' onClick={handleClose}>
          <div className='btn'>OK</div>
        </div>
      </div>
    </Modal>
  )
}

const Modal = styled.div`
  width: 100%;
  height:100%;
  position: relative;
  
  .content{
    .top{
      padding: 24px;
    }
    .title{

    }
    .debt-info{
      padding-top:24px;
      .info-item{
        display: flex;
        justify-content: space-between;
        line-height: 22px;
        
      }
      .book-item{
        padding-top:8px;
      }
    }
    .sub-title{
      font-weight: 400;
      font-size: 13px;
      line-height: 17px;
      color: rgba(255, 255, 255, 0.5);
      padding: 16px 0 24px;
    }
    .border-1{
      height:1px;
      background-color: rgba(255, 255, 255, 0.2);
    }
    .border-2{
      height:1px;
      background-color: rgba(255, 255, 255, 0.2);
    }
    
    .btns{
      display: flex;
      justify-content: flex-end;
      padding: 24px;
      .btn{
        width: 100px;
        height: 36px;        
        background: #21B36C;
        border-radius: 4px;
        text-align: center;
        font-weight: 600;
        font-size: 16px;
        line-height: 36px;
        color: #fff;
        cursor: pointer;
      }
    }
    
  }
  
`